import axios from "axios"
import { authorizeToCustomRest } from "../../features/customAuth/customAuth"
import { store } from "../../stateManagement/store"
import { showToastMessage } from "../../stateManagement/reducers"

export async function customFetchDocumentInfo(entityId: string, documentInfoApi: any, authRequestOptions: any, authToken?: string) {
    let { url, fetchPlan, view, requestMethod } = documentInfoApi ?? {}
    url = url?.replace(':entityId', entityId)
    let queryParams
    if (requestMethod === 'GET') {
        if (fetchPlan) queryParams = { fetchPlan }
        if (view) queryParams = { view }
    }
    try {
        const response = await axios(url, {
            method: requestMethod,
            headers: {
                "Authorization": `Bearer ${authToken}`
            },
            params: queryParams
        });
        const documentInfo = response?.data
        return documentInfo
    } catch (error: any) {
        const numberOfAuthTry = store.getState().customAuth.numberOfAuthTry
        if (error?.response?.status === 401) {
            if (numberOfAuthTry < 1) {
                store.dispatch(showToastMessage({ messageText: "Произошла ошибка при подключении к серверу", messageType: "error" }))
                await authorizeToCustomRest(authRequestOptions)
            }
        } else {
            store.dispatch(showToastMessage({ messageText: "Произошла ошибка при загрузке информации о документе", messageType: "error" }))
        }
    }
}

export async function customFetchFileJMIX(downloadApi: any, restAuthToken: any, authRequestOptions: any, fileRef: any) {
    let fileRefSplit = fileRef.split('?')
    let name = 'Файл'
    for (const fileRefPart of fileRefSplit) {
        if (fileRefPart.includes('name=')) {
            name = decodeURI(fileRefPart.split('=')[1]).replaceAll('+', '_')
        }
    }
    let queryParams
    const { requestMethod, url, param } = downloadApi ?? {}
    if (param) {
        queryParams = { [param]: fileRef }
    }
    try {
        const response = await axios(url, {
            method: requestMethod,
            headers: {
                "Authorization": `Bearer ${restAuthToken}`
            },
            params: queryParams,
            responseType: 'blob'
        });
        const fileData = await response.data
        let a = document.createElement("a");
        a.href = window.URL.createObjectURL(fileData);
        a.download = name;
        a.click();
    } catch (error: any) {
        if (error?.response?.status === 401) {
            await authorizeToCustomRest(authRequestOptions)
            return { error: 401 }
        }
        else {
            return { error }
        }
    }
}

export async function customFetchFileCUBA(downloadApi: any, restAuthToken: any, authRequestOptions: any, requestIsForDownload: boolean = false, value: any) {
    let fileName = 'Файл'
    let fileId
    if (typeof value === typeof {}) {
        const { id, name } = value ?? {}
        if (name) {
            fileName = name
        }
        fileId = id
    } else {
        fileId = value
    }
    let { requestMethod, url } = downloadApi ?? {}
    url = url?.replace(':entityId', fileId)
    try {
        const response = await axios(url, {
            method: requestMethod,
            headers: {
                "Authorization": `Bearer ${restAuthToken}`
            },
            responseType: 'blob'
        });
        const fileData = await response.data
        if (fileData) {
            if (requestIsForDownload) {
                let a: any = document.createElement("a");
                a.href = window.URL.createObjectURL(fileData);
                a.download = fileName;
                a.click();
            } else {
                return fileData
            }
        }
    } catch (error: any) {
        const numberOfAuthTry = store.getState().customAuth.numberOfAuthTry
        if (error?.response?.status === 401) {
            if (numberOfAuthTry < 1) {
                store.dispatch(showToastMessage({ messageText: "Возникла ошибка при подключении к серверу", messageType: "error" }))
                await authorizeToCustomRest(authRequestOptions)
            }
        } else {
            store.dispatch(showToastMessage({ messageText: "Возникла ошибка при загрузке документа для просмотра", messageType: "error" }))
        }
    }
}